import { useMemo } from "react";

import type { ActivationAlertsContractSocialMediaGroup } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";

import type { ValueMap } from "../filters/types";
import { useCommonAlertsQueryParams } from "../useCommonAlertsQueryParams";

import { useSocialAlertsFilterStore } from "./filters/useSocialAlertsFilterStore";

const matchesChannel = (group: ActivationAlertsContractSocialMediaGroup, selectedChannels: ValueMap) =>
    selectedChannels.has(group.socialMediaChannel);

export const useSocialAlertsQuery = () => {
    const selectedChannels = useSocialAlertsFilterStore((s) => s.selectedChannels);
    const isDefaultChannelsSelected = useSocialAlertsFilterStore((s) => s.isDefaultChannelsSelected);
    const params = useCommonAlertsQueryParams();

    const { data, ...rest } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsSocialMediaDetail",
            options: {
                refetchOnMount: true,
            },
        },
        params,
    );

    const filteredData = useMemo(
        () =>
            data?.filter((group) => {
                return isDefaultChannelsSelected || matchesChannel(group, selectedChannels);
            }),
        [data, selectedChannels, isDefaultChannelsSelected],
    );

    return { data: filteredData, ...rest };
};
